// Layout Types
import { PrivateLayout, PublicLayout,PrivateAssistRulesLayout } from "../layouts";



// Route Views
import FileUpload from "../containers/FileUpload";
import Documents from "../containers/Documents";
import DocumentsStatic from "../containers/Documents/index_static";
import DocumentDetail from "../containers/DocumentDetail";
import UnlabeledDocumentDetail from "../containers/UnlabeledDocumentDetail";
import Dashboard from "../containers/Dashboard";
import Pricing from "../containers/Pricing";
import NotificationList from "../containers/NotificationList";
import FileUploading from "../containers/FileUploading";
import SubDashboard from "../containers/SubDashboard";
import Location from "../containers/Location";
import LocationDetail from "../containers/LocationDetail";
import Operator from "../containers/Operator";
import OperatorDetail from "../containers/OperatorDetail";
import AccountSetting from "../containers/AccountSetting";
import DocumentLabels from "../containers/DocumentLabels";
import TermCondition from "../containers/TermCondition";
import DashboardNew from "../containers/DashboardNew";
import IncomeAnalyzer from "../containers/IncomeAnalyzer";
import Wise from "../containers/Wise";
import SubadminLogin from "../components/Auth/SubadminLogin";
import AddUser from "../containers/Operator/AddUser";
import EditUser from "../containers/Operator/EditUser";
import UserList from "../containers/UserListing";
import { roleItems } from "../utils/constants";
import DennisFile from "../containers/DennisFile";
import Dashboard2 from "../containers/Dashboard2";
import DocAssistRules from "../containers/DocumentDetail/DocumentView/docAssistRules";

const HomeRoutes = [
  {
    path: "/upload-file",
    exact: true,
    layout: PrivateLayout,
    component: FileUpload,
    role: [roleItems[1], roleItems[2], roleItems[3], roleItems[4]],
    permissions: ["document_management"],
  },
  {
    path: "/documents-old",
    exact: true,
    layout: PrivateLayout,
    component: Documents,
    role: [roleItems[1], roleItems[2], roleItems[3], roleItems[4]],
    permissions: ["document_management", "document_edit_management"],
  },
  {
    path: "/documents",
    exact: true,
    layout: PrivateLayout,
    component: DocumentsStatic,
  },
  {
    path: "/documentDetail",
    exact: true,
    layout: PrivateLayout,
    component: DocumentDetail,
    role: [roleItems[1], roleItems[2], roleItems[3], roleItems[4]],
    permissions: ["document_management", "document_edit_management"],
  },
  {
    path: "/dennis",
    exact: true,
    layout: PrivateLayout,
    component: UnlabeledDocumentDetail,
    role: [roleItems[1], roleItems[2], roleItems[3], roleItems[4]],
    permissions: ["document_management", "document_edit_management"],
  },
  {
    path: "/dashboard-old",
    exact: true,
    layout: PrivateLayout,
    component: Dashboard,
  },
  {
    path: "/dashboard",
    exact: true,
    layout: PrivateLayout,
    component: DashboardNew,
  },
  {
    path: "/dashboard2",
    exact: true,
    layout: PrivateLayout,
    component: Dashboard2,
  },
  {
    path: "/pricing",
    exact: true,
    layout: PrivateLayout,
    component: Pricing,
    role: [roleItems[1], roleItems[2], roleItems[3], roleItems[4]],
    roleType: roleItems[2],
    permissions: ["billing_management"],
  },
  {
    path: "/notification-list",
    exact: true,
    layout: PrivateLayout,
    component: NotificationList,
  },

  {
    path: "/uploading-file",
    exact: true,
    layout: PrivateLayout,
    component: FileUploading,
  },
  {
    path: "/sub-dashboard",
    exact: true,
    layout: PrivateLayout,
    component: SubDashboard,
  },
  {
    path: "/workgroup",
    exact: true,
    layout: PrivateLayout,
    component: Location,
  },
  {
    path: "/workgroup-detail",
    exact: true,
    layout: PrivateLayout,
    component: LocationDetail,
  },
  {
    path: "/users",
    exact: true,
    layout: PrivateLayout,
    component: UserList,
    role: [roleItems[1], roleItems[2], roleItems[3], roleItems[4]],
    roleType: roleItems[2],
    permissions: ["user_management"],
  },
  {
    path: "/user-detail",
    exact: true,
    layout: PrivateLayout,
    component: OperatorDetail,
    role: [roleItems[1], roleItems[2], roleItems[3], roleItems[4]],
    roleType: roleItems[2],
    permissions: ["user_management"],
  },
  {
    path: "/account-setting",
    exact: true,
    layout: PrivateLayout,
    component: AccountSetting,
  },
  {
    path: "/document-labels",
    exact: true,
    layout: PrivateLayout,
    component: DocumentLabels,
  },
  {
    path: "/terms-and-condition/cookie-notice",
    exact: true,
    layout: PublicLayout,
    component: TermCondition,
  },
  {
    path: "/terms-and-condition/california-privacy-disclosure",
    exact: true,
    layout: PublicLayout,
    component: TermCondition,
  },
  {
    path: "/terms-and-condition/privacy-notice",
    exact: true,
    layout: PublicLayout,
    component: TermCondition,
  },
  {
    path: "/terms-and-condition/california-privacy-disclosure",
    exact: true,
    layout: PublicLayout,
    component: TermCondition,
  },
  {
    path: "/terms-and-condition/use-site",
    exact: true,
    layout: PublicLayout,
    component: TermCondition,
  },
  {
    path: "/income_analyzer",
    exact: true,
    layout: PrivateLayout,
    component: IncomeAnalyzer,
  },
  {
    path: "/wise",
    exact: true,
    layout: PrivateLayout,
    component: Wise,
  },
  {
    path: "/add-user",
    exact: true,
    layout: PrivateLayout,
    component: AddUser,
    role: [roleItems[1], roleItems[2], roleItems[3], roleItems[4]],
    roleType: roleItems[2],
    permissions: ["user_management"],
  },
  {
    path: "/edit-user",
    exact: true,
    layout: PrivateLayout,
    component: EditUser,
    role: [roleItems[1], roleItems[2], roleItems[3], roleItems[4]],
    roleType: roleItems[2],
    permissions: ["user_management"],
  },

  {
    path: "/dennis-file",
    exact: true,
    layout: PrivateLayout,
    component: DennisFile,
  },
  {
    path: "/docAssistRules",
    exact: true,
    layout: PrivateAssistRulesLayout,
    component: DocAssistRules,
    role: [roleItems[1], roleItems[2], roleItems[3], roleItems[4]],
    permissions: ["document_management", "document_edit_management"],
  },

  // {
  // 	layout: PrivateLayout,
  // 	component: NotFound
  // }
];

export default HomeRoutes;
